var _circle, _circle2, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_73)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 48,
    r: 15,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_73)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5988 23.2244C48.9531 23.6166 48.8596 23.9502 48.8596 25.8605C48.8596 27.1733 48.9016 27.6489 49.0413 27.9181C49.5971 28.9893 51.4079 28.9893 51.9637 27.9181C52.1035 27.6489 52.1455 27.1733 52.1455 25.8605C52.1455 23.9502 52.052 23.6166 51.4063 23.2244C50.9142 22.9252 50.0909 22.9252 49.5988 23.2244ZM31.5396 30.6463C30.8256 30.9561 30.4352 31.7824 30.6139 32.6054C30.7255 33.1195 32.8808 35.3293 33.4546 35.5181C34.6809 35.9213 35.9324 34.7218 35.5866 33.4743C35.4999 33.1613 35.1549 32.7067 34.4449 31.9701C33.101 30.5761 32.4184 30.265 31.5396 30.6463ZM67.9885 30.7085C67.7626 30.8284 67.121 31.3928 66.5628 31.9627C65.8178 32.7231 65.514 33.1237 65.4209 33.4683C65.0799 34.7304 66.3189 35.9231 67.5504 35.5181C68.1243 35.3293 70.2795 33.1195 70.3911 32.6054C70.7092 31.141 69.2878 30.0189 67.9885 30.7085ZM48.0967 35.3216C42.3704 36.2654 37.6101 40.2874 35.7919 45.7179C35.2316 47.3912 35.0727 48.4927 35.0799 50.6544C35.0855 52.3686 35.1285 52.8219 35.3914 53.9437C36.1309 57.0996 37.9062 60.0982 40.1808 62.0337C42.371 63.8972 42.9918 64.7449 43.175 66.1217L43.2568 66.7354H50.5177H57.7786L57.7825 66.3553C57.788 65.8012 58.1542 64.8311 58.6117 64.1586C58.8313 63.8359 59.5476 63.1295 60.2036 62.589C66.5388 57.3685 67.8246 48.6393 63.2619 41.8255C62.5205 40.7181 60.3333 38.5481 59.2135 37.8086C57.5528 36.7118 55.5851 35.8799 53.6125 35.4402C52.4874 35.1894 49.3127 35.1211 48.0967 35.3216ZM23.8668 48.9296C23.0673 49.3315 22.732 50.595 23.2436 51.278C23.7878 52.0044 23.9657 52.0579 25.8371 52.0579C27.7677 52.0579 28.1349 51.951 28.5688 51.2627C28.8652 50.7924 28.8258 49.8507 28.4905 49.3929C28.0766 48.828 27.676 48.7247 25.8988 48.725C24.5851 48.7251 24.1956 48.7642 23.8668 48.9296ZM73.2108 48.8369C73.0818 48.8904 72.8222 49.0965 72.6339 49.2947C72.1764 49.7767 72.0833 50.7029 72.4363 51.2627C72.8702 51.951 73.2374 52.0579 75.168 52.0579C77.0449 52.0579 77.2163 52.0057 77.7707 51.2656C78.0751 50.8593 78.0766 50.0514 77.774 49.5291C77.3797 48.8488 76.9594 48.7241 75.0885 48.7323C74.1849 48.7363 73.3399 48.7833 73.2108 48.8369ZM43.2834 70.2732C43.548 72.6912 44.6316 74.5531 46.4908 75.785C49.3833 77.7012 53.1544 77.3196 55.6216 74.8608C56.8557 73.6309 57.5049 72.2001 57.7295 70.2148L57.8056 69.5423H50.5045H43.2035L43.2834 70.2732Z",
    fill: "url(#paint1_linear_1062_73)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5988 23.2244C48.9531 23.6166 48.8596 23.9502 48.8596 25.8605C48.8596 27.1733 48.9016 27.6489 49.0413 27.9181C49.5971 28.9893 51.4079 28.9893 51.9637 27.9181C52.1035 27.6489 52.1455 27.1733 52.1455 25.8605C52.1455 23.9502 52.052 23.6166 51.4063 23.2244C50.9142 22.9252 50.0909 22.9252 49.5988 23.2244ZM31.5396 30.6463C30.8256 30.9561 30.4352 31.7824 30.6139 32.6054C30.7255 33.1195 32.8808 35.3293 33.4546 35.5181C34.6809 35.9213 35.9324 34.7218 35.5866 33.4743C35.4999 33.1613 35.1549 32.7067 34.4449 31.9701C33.101 30.5761 32.4184 30.265 31.5396 30.6463ZM67.9885 30.7085C67.7626 30.8284 67.121 31.3928 66.5628 31.9627C65.8178 32.7231 65.514 33.1237 65.4209 33.4683C65.0799 34.7304 66.3189 35.9231 67.5504 35.5181C68.1243 35.3293 70.2795 33.1195 70.3911 32.6054C70.7092 31.141 69.2878 30.0189 67.9885 30.7085ZM48.0967 35.3216C42.3704 36.2654 37.6101 40.2874 35.7919 45.7179C35.2316 47.3912 35.0727 48.4927 35.0799 50.6544C35.0855 52.3686 35.1285 52.8219 35.3914 53.9437C36.1309 57.0996 37.9062 60.0982 40.1808 62.0337C42.371 63.8972 42.9918 64.7449 43.175 66.1217L43.2568 66.7354H50.5177H57.7786L57.7825 66.3553C57.788 65.8012 58.1542 64.8311 58.6117 64.1586C58.8313 63.8359 59.5476 63.1295 60.2036 62.589C66.5388 57.3685 67.8246 48.6393 63.2619 41.8255C62.5205 40.7181 60.3333 38.5481 59.2135 37.8086C57.5528 36.7118 55.5851 35.8799 53.6125 35.4402C52.4874 35.1894 49.3127 35.1211 48.0967 35.3216ZM23.8668 48.9296C23.0673 49.3315 22.732 50.595 23.2436 51.278C23.7878 52.0044 23.9657 52.0579 25.8371 52.0579C27.7677 52.0579 28.1349 51.951 28.5688 51.2627C28.8652 50.7924 28.8258 49.8507 28.4905 49.3929C28.0766 48.828 27.676 48.7247 25.8988 48.725C24.5851 48.7251 24.1956 48.7642 23.8668 48.9296ZM73.2108 48.8369C73.0818 48.8904 72.8222 49.0965 72.6339 49.2947C72.1764 49.7767 72.0833 50.7029 72.4363 51.2627C72.8702 51.951 73.2374 52.0579 75.168 52.0579C77.0449 52.0579 77.2163 52.0057 77.7707 51.2656C78.0751 50.8593 78.0766 50.0514 77.774 49.5291C77.3797 48.8488 76.9594 48.7241 75.0885 48.7323C74.1849 48.7363 73.3399 48.7833 73.2108 48.8369ZM43.2834 70.2732C43.548 72.6912 44.6316 74.5531 46.4908 75.785C49.3833 77.7012 53.1544 77.3196 55.6216 74.8608C56.8557 73.6309 57.5049 72.2001 57.7295 70.2148L57.8056 69.5423H50.5045H43.2035L43.2834 70.2732Z",
    stroke: "url(#paint2_linear_1062_73)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1062_73)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4025 44.9781C47.5572 47.8225 46.0271 50.2398 46.0023 50.3498C45.9649 50.5149 46.3761 50.5499 48.3532 50.5499C50.5709 50.5499 50.7437 50.5686 50.6738 50.8011C50.5634 51.1676 49.053 58.7331 49.053 58.9195C49.053 59.0188 49.1014 59.0267 49.1839 58.9407C49.5455 58.5639 56.0427 48.181 55.9998 48.0485C55.9675 47.9484 55.102 47.8804 53.5416 47.8548C51.3362 47.8188 51.1393 47.7947 51.2049 47.5677C51.4627 46.6758 52.8373 40.164 52.8017 40.0038C52.7775 39.8953 51.2478 42.1337 49.4025 44.9781Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_73",
    x: 20.85,
    y: 20.85,
    width: 59.3,
    height: 58.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_73",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1062_73",
    x: 44.1,
    y: 38.1,
    width: 13.8,
    height: 22.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_73",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_73",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_73",
    x1: 28.8856,
    y1: 27.9821,
    x2: 87.7854,
    y2: 59.0445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_73",
    x1: 55.0833,
    y1: 32,
    x2: 75.0769,
    y2: 79.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.5533f20b52b1145b3cc72cb6fd435f1b.svg";
export { ForwardRef as ReactComponent };